const PropTypes = require("prop-types");
// @ vendors
const React = require("react");
const PureRenderMixin = require("react-addons-pure-render-mixin");
// @ commons
const { formatText } = require("core/i18n").i18n;
// @ components
const WizardSuccess = require("components/commons/wizardSuccess/wizardSuccess");
// @ utilities
const { changeBiocatchContext } = require("utilities/biocatch");
// @ constants
const biocatch = require("constants/biocatch");

class AddBeneficiarySuccessStep extends React.Component {
    constructor(props) {
        super(props);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(
            this
        );
    }

    render() {
        const {
            immAddBeneficiary,
            immBeneficiaries,
            onTransferBeneficiaryClick
        } = this.props;
        const titleKey = immAddBeneficiary.get("isEditing")
            ? "transfersAgenda-editAgendaSuccess"
            : "transfersAgenda-addToAgendaSuccess";
        const title = formatText(titleKey, [
            immAddBeneficiary.get("name"),
            immAddBeneficiary.get("alias")
        ]);
        const mainButton = {
            label: formatText("transfersAgenda-transferButtonLabel"),
            modifier: "secondary ",
            loading: immBeneficiaries.get("isFetching")
        };
        const secondaryButton = {
            url: "/myprofile/transfers/agenda",
            label: formatText(
                "transfersAgenda-addBeneficiarySuccessScreenButton"
            ).toUpperCase()
        };

        changeBiocatchContext(biocatch.SUCCESSFUL_OPERATION);

        return (
            <div className="add-beneficiary-success-step">
                <WizardSuccess
                    successMessage={title}
                    mainButton={mainButton}
                    onMainButtonClick={onTransferBeneficiaryClick}
                    secondaryButton={secondaryButton}
                    secondaryButtonStyle={
                        __CONTACT_CENTER__ ? "secondary" : null
                    }
                />
            </div>
        );
    }
}

AddBeneficiarySuccessStep.propTypes = {
    immAddBeneficiary: PropTypes.object.isRequired,
    immBeneficiaries: PropTypes.object.isRequired,
    onTransferBeneficiaryClick: PropTypes.func.isRequired
};

module.exports = AddBeneficiarySuccessStep;
